import { useEffect, useState } from 'react';
import { ProfitService } from '../services';
import { v4 } from 'uuid';
import { Button, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

function formatting(date, data, setState, onPressEdit) {
  return data.map(item => {
    const { code, codeName, estimatedPrice, id, isAlarm, opinion } = item;
    return [
      (id + '').slice(0, 8) + '...',
      opinion,
      `${codeName} (${code})`,
      estimatedPrice,
      <Button
        variant={'contained'}
        color={'primary'}
        disabled={isAlarm}
        onClick={() => alert('지원 예정입니다.')}
      >
        {'전송'}
      </Button>,
      <>
        <IconButton onClick={() => onPressEdit(item)}>
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="delete"
          onClick={async () => {
            if (window.confirm('삭제하시겠습니까?')) {
              const newData = await ProfitService.remove(date, item);
              setState(formatting(date, newData, setState, onPressEdit));
            }
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    ];
  });
}

export const useStockList = () => {
  const [state, setState] = useState([]);
  useEffect(() => {
    ProfitService.stockLists().then(res => setState(res));
  }, []);
  return state;
};

export const useProfits = (date, onPressEdit) => {
  const [data, setData] = useState();

  useEffect(() => {
    ProfitService.fetchByDate(date).then(response => {
      setData(formatting(date, response, setData, onPressEdit));
    });
  }, [date, onPressEdit]);

  return {
    headers: ['id', '의견', '종목명(코드)', '예상 금액', '알림', ''],
    data,
    updateItem: async params => {
      const {
        id = v4(),
        isAlarm = false,
        code,
        codeName,
        estimatedPrice,
        opinion
      } = params;
      const newItem = {
        id,
        code,
        codeName,
        estimatedPrice,
        opinion,
        isAlarm
      };
      const data = await ProfitService.update(date, newItem);
      setData(formatting(date, data, setData, onPressEdit));
    }
  };
};
